import { FuncaoService, GlobalService, LoginContabil, Relatorio, RequisicaoItemMovimento, RequisicaoMovimento } from "eddydata-lib";

export class RequisicaoAutorizacaoRpt {

  public orientacao: 'landscape' | 'portrait' = 'landscape';
  public tamanhoFonteTitulos = 8;
  public tamanhoFonteItens = 7;

  protected funcaoService: FuncaoService = new FuncaoService();

  constructor(
    private login: LoginContabil,
    public globalService: GlobalService
  ) { }

  public imprimir(model: RequisicaoMovimento) {
    const titulo = 'REQUISIÇÃO DE MATERIAIS';

    Relatorio.imprimirPersonalizado(titulo, this.login.usuario.nome, this.login.usuario.sobrenome,
      this.login.orgao.nome, this.login.brasao,
      this.montarConteudo(model),
      this.orientacao, titulo, this.layoutRelatorio(), true, false);
  }

  protected layoutRelatorio(): {} {
    return {
      linhas: {
        hLineWidth() {
          return 1;
        },
        vLineWidth() {
          return 1;
        },
        hLineColor() {
          return 'black';
        },
        paddingLeft() {
          return 3;
        },
        paddingRight() {
          return 3;
        }
      }
    };
  }

  protected montarConteudo(movimento: RequisicaoMovimento): {}[] {
    const conteudo: {}[] = [];

    conteudo.push(this.dadosCabecalho()
      .concat(this.dadosIdentificacao(movimento))
      .concat(this.dadosItens(movimento)));

    return conteudo;
  }

  private dadosCabecalho(): {}[] {
    let brasaoImage: {};
    if (this.login.brasao) {
      brasaoImage = {
        image: this.login.brasao,
        width: 70,
        alignment: 'left',
        margin: [0, 0, 0, 0],
        border: [false, false, false, false]
      };
    } else {
      brasaoImage = { margin: [0, 10, 0, 0], text: '', border: [false, false, false, false] };
    }

    brasaoImage['rowSpan'] = 2;

    const conteudo = [];

    conteudo.push([brasaoImage, { text: this.login.orgao.nome, bold: true, alignment: 'center', fontSize: 13, border: [false, false, false, false] }]);
    conteudo.push([
      { text: '' },
      { text: 'REQUISIÇÃO DE MATERIAIS', bold: true, alignment: 'center', fontSize: 13, border: [false, false, false, false], margin: [0, 10] }
    ]);

    return [{
      layout: 'linhas',
      table: {
        widths: [50, '*'],
        body: conteudo
      }
    }];
  }

  private dadosIdentificacao(movimento: RequisicaoMovimento): {}[] {
    const destino = movimento?.setor_almoxarifado?.setor?.nome ?? '';
    const requisitante = movimento?.destinatario ?? movimento?.usuario?.nome ?? '';
    const codigo = movimento?.codigo ?? '';
    const data = this.data(movimento?.data_cadastro);

    const conteudo: any[] = [
      [
        { text: [{ text: 'DESTINO:  ', bold: true }, { text: destino }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: [{ text: 'REQUISITANTE:  ', bold: true }, { text: requisitante }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: [{ text: 'RRM:  ', bold: true }, { text: codigo }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: [{ text: 'DATA:  ', bold: true }, { text: data }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
      ],
    ];

    if (movimento?.paciente) {
      conteudo.push([
        { text: [{ text: 'PACIENTE:  ', bold: true }, { text: movimento.nome_paciente ?? '' }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: '', fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: [{ text: 'MCV:  ', bold: true }, { text: movimento.mcv_paciente ?? '' }], fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
        { text: '', fontSize: this.tamanhoFonteItens, border: [false, true, false, false], margin: [0, 5] },
      ]);
    }

    return [{
      layout: 'linhas',
      margin: [0, 10],
      table: {
        widths: ['*', '*', 'auto', 'auto'],
        body: conteudo
      }
    }];
  }

  private dadosItens(movimento: RequisicaoMovimento): {}[] {
    const conteudo = [];

    conteudo.push([
      this.tituloColuna('CÓDIGO'),
      this.tituloColuna('PRODUTO'),
      this.tituloColuna('STATUS'),
      this.tituloColuna('LOTE'),
      this.tituloColuna('VENCIMENTO'),
      this.tituloColuna('UNID.'),
      this.tituloColuna('REQUISITADO'),
      this.tituloColuna('MÉDIA'),
      this.tituloColuna('SALDO'),
      this.tituloColuna('ACEITO'),
    ]);

    for (const item of movimento.itens ?? []) {
      conteudo.push([
        this.celula(item?.produto_unidade?.produto?.codigo, 'center'),
        this.celulaProduto(item),
        this.celula(item?.status ? this.globalService.tituloStatusRequisicao(item.status) : '', 'center'),
        this.celula(item?.lote, 'center'),
        this.celula(this.data(item?.vencimento), 'center'),
        this.celula(item?.produto_unidade?.unidade?.nome, 'center'),
        this.celula(this.numero(item?.qtd_requisitada), 'right'),
        this.celula(this.numero(item?.['media_consumo_mensal']), 'right'),
        this.celula(this.numero(item?.['saldo_atual']), 'right'),
        this.celula(this.numero(item?.qtd_aceita), 'right'),
      ]);
    }

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: [45, '*', 58, 50, 55, 40, 58, 45, 45, 45],
        body: conteudo
      }
    }];
  }

  private tituloColuna(text: string): {} {
    return { text, alignment: 'center', bold: true, fontSize: this.tamanhoFonteTitulos };
  }

  private celula(text: any, alignment: string): {} {
    return { text: text ?? '', alignment, fontSize: this.tamanhoFonteItens };
  }

  private celulaProduto(item: RequisicaoItemMovimento): {} {
    const produto = item?.produto_unidade?.produto;
    const texto: any[] = [{ text: produto?.nome ?? '' }];

    if (item?.produto_unidade_troca) {
      const produtoTroca = item.produto_unidade_troca.produto;
      const unidadeTroca = item.produto_unidade_troca.unidade;
      texto.push({
        text: `\n${item.justificativa_troca ?? 'Troca'}: ${produtoTroca?.codigo ?? ''} ${produtoTroca?.nome ?? ''} - ${unidadeTroca?.nome ?? ''}`,
        color: 'red',
        italics: true
      });
    }

    return { text: texto, alignment: 'left', fontSize: this.tamanhoFonteItens };
  }

  private data(valor: any): string {
    return valor ? this.funcaoService.converteDataBR(valor) : '';
  }

  private numero(valor: any): string {
    if (valor === null || valor === undefined || valor === '') {
      return '';
    }

    return this.funcaoService.convertToBrNumber(valor, 5);
  }
}
